import React from 'react';
import Icon from '../../../components/AppIcon';

const EmailStatsBar = ({ totalTemplates, filteredCount, activeCategory }) => {
  const stats = [
    {
      icon: 'Mail',
      label: 'Total Templates',
      value: totalTemplates,
      color: 'text-primary'
    },
    {
      icon: 'Filter',
      label: 'Filtered Results',
      value: filteredCount,
      color: 'text-accent'
    },
    {
      icon: 'Tag',
      label: 'Active Category',
      value: activeCategory === 'all' ? 'All' : activeCategory?.charAt(0)?.toUpperCase() + activeCategory?.slice(1),
      color: 'text-secondary'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {stats?.map((stat, index) => (
          <div 
            key={index}
            className="flex items-center gap-4 p-4 bg-muted/30 rounded-lg"
          >
            <div className={`w-12 h-12 rounded-lg bg-background flex items-center justify-center ${stat?.color}`}>
              <Icon name={stat?.icon} size={24} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground font-caption mb-1">
                {stat?.label}
              </p>
              <p className="text-xl md:text-2xl font-semibold text-foreground whitespace-nowrap">
                {stat?.value}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmailStatsBar;